const PLACEHOLDERS = {
  SEARCH: 'Search...',
  SELECT: 'Select...',
  FIELD_DATE: 'Select date',
};

export { PLACEHOLDERS };
